var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.49 105.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .sc-cls-1 {\n        fill: #39fdc1;\n      }\n\n      .sc-cls-2 {\n        fill: #fff;\n      }\n\n      .sc-cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 6px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "sc-cls-1",
    cx: 52.74,
    cy: 52.74,
    r: 52.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sc-cls-2",
    cx: 52.74,
    cy: 52.74,
    r: 11.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "sc-cls-3",
    cx: 52.74,
    cy: 52.74,
    rx: 19.03,
    ry: 38.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "sc-cls-3",
    cx: 750,
    cy: 382.4,
    rx: 19.03,
    ry: 38.71,
    transform: "translate(-653.42 511.06) rotate(-60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "sc-cls-3",
    cx: 750,
    cy: 382.4,
    rx: 38.71,
    ry: 19.03,
    transform: "translate(-787.98 96.58) rotate(-30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/Science.0ecaee72f20c1345b84bec0bba68eeea.svg";
export { ForwardRef as ReactComponent };